(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfSyncScrollLeft', (function(_this) {
    return function() {
      return {
        restrict: 'A',
        link: function($scope, element, attrs) {
          var other;
          other = $(attrs.mfSyncScrollLeft);
          return other.on('scroll', function(e) {
            return $(element).scrollLeft(other.scrollLeft());
          });
        }
      };
    };
  })(this));

}).call(this);
